"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioInline = void 0;
var _react = _interopRequireDefault(require("react"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var RadioInline = exports.RadioInline = function RadioInline(_ref) {
  var field = _ref.field,
    label = _ref.label,
    options = _ref.options;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement("div", null, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement("label", {
      key: option.value,
      className: "radio-inline"
    }, /*#__PURE__*/_react["default"].createElement("input", _extends({
      type: "radio"
    }, (0, _domOnlyProps["default"])(field), {
      value: option.value,
      checked: field.value === option.value
    })), ' ', option.label);
  })));
};